(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationInsuranceComponentDetails',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var label_name      = 'reservationinsurancecomponentdetails';
		var provider_select = $('#' + label_name + '-insurance_company_id');
		var product_select  = $('#' + label_name + '-insurance_company_product_id');

		// when the "Insurance Provider" select changes,
		// populate the "Insurance Product" options
		provider_select.change(function onProviderChange()
		{
			var vendor_id = provider_select.val();

			Adzuki.Ajax.get('/Reservations/getInsuranceProducts/' + vendor_id)
				.then(function insuranceProducts(response)
				{
					product_select.empty();

					if ($.isEmptyObject(response)) {
						product_select.attr('disabled', 'disabled');
					} else {
						product_select.removeAttr('disabled');
					}

					$.each(response, function onEachProduct(product_id, product_name) {
						var markup = '';
						markup += '<option value="' + product_id + '">';
						markup += product_name + '</option>';

						product_select.append(markup);
					});
				});
		});

		// when the "On Quote" radio inputs change,
		// show/hide the policy number and purchase date fields.
		$('#on-quote-wrapper input[type="radio"').change(function onQuoteChange(event)
		{
			var on_quote = $('#' + label_name + '-on_quote-1').is(':checked');

			if (on_quote) {
				$('.policy-number, .purchase-date, .te-thank-you').addClass('hidden');
				return;
			}

			$('.policy-number, .purchase-date, .te-thank-you').removeClass('hidden');

		});

		$('#my-trips-purchase-wrapper input[type="radio"').change(function onMytripsPurchaseChange(event)
		{
			var mytrips_purchase = $('#' + label_name + '-mytrips_purchasable-1').is(':checked');
			if (mytrips_purchase) {
				$('#can-purchase-clients').removeClass('hidden');
			} else {
				$('#can-purchase-clients').addClass('hidden'	);
			}
		});

		// when the coverage start date changes,
		// set the coverage end date accordingly
		// adjust the coverage end date only if the new start date is after the end date
		$('#' + label_name + '-start_date').on('dp.change', function onCoverageChangeDate(event)
		{
			var start_date = event.date;
			var end_date   = $('#' + label_name + '-end_date');

			if (start_date) {
				if (start_date.isAfter(end_date.data('DateTimePicker').date())) {
					end_date.data('DateTimePicker').date(start_date);
				}
			}
		});

		$('input[type="radio"').trigger('change');
	};

}(jQuery, window.Adzuki || {}));
